<div class="grid">
  <div class="md:col-6 col-12">
    <p-card
      header="Описание"
      styleClass="mt-3">
      <div class="p-fluid">
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="data.name"
              class="w-full"
              [isError]="$any(errors?.name)"></crm-input-text>
            @if (errors?.name) {
              <small class="p-error">
                {{ errors.name | join }}
              </small>
            }
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [(ngModel)]="data.disabled"
              [binary]="true"
              inputId="disabled"></p-checkbox>
            <label [for]="'disabled'">Неактивный</label>
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Тема письма</label>
            <crm-template-subject-input
              [(subject)]="data.title"
              [isError]="$any(errors?.title)"
              class="w-full"></crm-template-subject-input>
            @if (errors?.title) {
              <small class="p-error">
                {{ errors.title | join }}
              </small>
            }
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Текст сообщения</label>
            <crm-template-subject-editor
              [(value)]="data.text"
              height="250px"></crm-template-subject-editor>
            @if (errors?.text) {
              <small class="p-error">
                {{ errors.text | join }}
              </small>
            }
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Тип</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="data.type"
              class="w-full {{ errors?.type ? 'ng-invalid ng-dirty' : '' }}"
              optionValue="name"
              [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | mailingTypeName }}
              </ng-template>
            </crm-single-select>
            @if (errors?.type) {
              <small class="p-error">
                {{ errors.type | join }}
              </small>
            }
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Действует до</label>
            <crm-datepicker
              [(value)]="data.activeUntil"
              (valueChange)="data.disabled = false"
              [inputStyleClass]="errors?.activeUntil ? 'ng-invalid ng-dirty' : ''"
              [minDate]="today"
              appendTo="body"
              styleClass="w-full"></crm-datepicker>
            @if (errors?.activeUntil) {
              <small class="p-error">
                {{ errors.activeUntil | join }}
              </small>
            }
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Канал</label>
            <crm-single-select
              [options]="channels"
              [(selectedItem)]="data.channel"
              (selectedItemChange)="changeChannel($event)"
              class="w-full {{ errors?.channel ? 'ng-invalid ng-dirty' : '' }}"
              optionValue="name"
              [styleClass]="errors?.channel ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item"
                >{{ type.value | mailingChannelName }}</ng-template
              >
            </crm-single-select>
            @if (errors?.channel) {
              <small class="p-error">
                {{ errors.channel | join }}
              </small>
            }
          </div>

          @if (data.channel === MailingChannelEnum.SMS) {
            <div class="field lg:col-6 col-12">
              <label class="font-medium required-field">SMS сервис</label>
              <crm-newsletter-sms-sender-single-select
                [(smsSender)]="data.smsSender"
                [arraySms]="arraySms"
                [isError]="$any(errors?.smsSender)"
                [showClear]="true"
                appendTo="body"></crm-newsletter-sms-sender-single-select>
              @if (errors?.smsSender) {
                <small class="p-error">
                  {{ errors.smsSender | join }}
                </small>
              }
            </div>
          }

          @if (data.channel === MailingChannelEnum.EMAIL) {
            <div class="field lg:col-6 col-12">
              <label class="font-medium required-field">Тип почтового сервиса</label>
              <p-selectButton
                [options]="emailOptions"
                [(ngModel)]="data.emailSender.gate"
                (ngModelChange)="changeEmailType($event)">
              </p-selectButton>
            </div>

            @if (data.emailSender.gate === EmailGateEnum.FRM) {
              <div class="field lg:col-6 col-12">
                <label class="font-medium required-field">Email сервис</label>
                <crm-newsletter-email-sender-single-select
                  [(email)]="data.emailSender.email"
                  [emails]="emails"
                  [isError]="$any(errors?.emailSender)"
                  [showClear]="true"
                  appendTo="body"></crm-newsletter-email-sender-single-select>
                @if (errors?.emailSender) {
                  <small class="p-error">
                    {{ errors.emailSender | join }}
                  </small>
                }
              </div>
            }

            @if (data.emailSender.gate === EmailGateEnum.MAIN_SMS) {
              <div class="field lg:col-6 col-12">
                <label class="font-medium required-field">MainSMS сервис</label>
                <crm-newsletter-email-main-sms-sender-single-select
                  [(email)]="data.emailSender.mainSmsAccount"
                  (emailChange)="changeEmailMainSms($event)"
                  [emails]="arraySms"
                  [isError]="$any(errors?.emailSender)"
                  [showClear]="true"
                  appendTo="body"></crm-newsletter-email-main-sms-sender-single-select>
                @if (errors?.emailSender) {
                  <small class="p-error">
                    {{ errors.emailSender | join }}
                  </small>
                }
              </div>

              @if (data.emailSender.mainSmsAccount) {
                <div class="field lg:col-6 col-12">
                  <label class="font-medium required-field">Email</label>
                  <crm-single-select
                    [options]="data.emailSender.mainSmsAccount.emails"
                    [(selectedItem)]="data.emailSender.mainSmsAccountEmail"
                    class="w-full {{ errors?.emailSender ? 'ng-invalid ng-dirty' : '' }}"
                    optionValue="name"
                    [styleClass]="errors?.emailSender ? 'ng-invalid ng-dirty' : ''"
                    [filter]="false"
                    [showClear]="true"
                    appendTo="body">
                  </crm-single-select>
                  @if (errors?.emailSender) {
                    <small class="p-error">
                      {{ errors.emailSender | join }}
                    </small>
                  }
                </div>
              }
            }
          }
        </div>

        @if (data.type === MailingTypeEnum.DEBTORS) {
          <ng-template
            [ngTemplateOutlet]="reusableTemplate"
            [ngTemplateOutletContext]="{ data: data }"></ng-template>
        }

        @if ([MailingTypeEnum.DEBTORS_FROM_FILE].includes($any(data.type))) {
          <div class="field">
            <label class="font-medium required-field">Файл</label>
            <crm-file-uploader
              [isUploadFiles]="false"
              [uploadingFiles]="loadingFile"
              (filesSelected)="selectedFileDebtor($event)"
              label="Файл"></crm-file-uploader>
            @if (errors?.fileDebtorTargets) {
              <small class="p-error">
                {{ errors.fileDebtorTargets | join }}
              </small>
            }
          </div>
        }

        @if ([MailingTypeEnum.DEBTORS_FROM_FILE, MailingTypeEnum.DEBTORS].includes($any(data.type))) {
          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="data.includingAdvancePayment"
              [binary]="true"
              inputId="includingAdvancePayment"></p-checkbox>
            <label [for]="'includingAdvancePayment'">С учетом аванс</label>
          </div>
        }

        @if (data.type === MailingTypeEnum.DEBTORS && data.channel === MailingChannelEnum.EMAIL) {
          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="data.attachBills"
              [binary]="true"
              inputId="attachBills"></p-checkbox>
            <label [for]="'attachBills'">Отправлять счета</label>
          </div>
        }
      </div>
    </p-card>

    @if (data.type === MailingTypeEnum.BILLS) {
      <div class="mt-3">
        <p-card header="Поиск счетов">
          <ng-template
            [ngTemplateOutlet]="reusableTemplate"
            [ngTemplateOutletContext]="{ data: data }"></ng-template>
        </p-card>
      </div>
    }

    @if (data.type === MailingTypeEnum.DOCUMENTS) {
      <div class="mt-3">
        <p-card header="Поиск документов">
          <ng-template
            [ngTemplateOutlet]="reusableTemplate"
            [ngTemplateOutletContext]="{ data: data }"></ng-template>
        </p-card>
      </div>
    }

    <div class="mt-3">
      <crm-planning-periodicity-card
        [planning]="data.planning"
        [errors]="$any(errors?.planning)"></crm-planning-periodicity-card>
    </div>
  </div>

  <div class="md:col-6 col-12">
    <p-card
      header="Аудиторы"
      styleClass="md:mt-3">
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [(selectedUsers)]="data.userAuditors"
            [isError]="$any(errors?.userAuditors)"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
          @if (errors?.userAuditors) {
            <p class="p-error">
              {{ errors.userAuditors | join }}
            </p>
          }
        </div>
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-user-group-multi-select
            [(selectedUserGroups)]="data.groupAuditors"
            [isFloatLabel]="false"
            [class]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-user-group-multi-select>
          @if (errors?.groupAuditors) {
            <p class="p-error">
              {{ errors.groupAuditors | join }}
            </p>
          }
        </div>
      </div>
    </p-card>

    @if (data.type === MailingTypeEnum.HELPDESK) {
      <p-card
        header="Участники рассылки"
        styleClass="md:mt-3">
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Контакты</label>
            <crm-multi-select
              [(selectedItems)]="data.externalUsers"
              [options]="externalUsers"
              [showToggleAll]="true"
              optionLabel="profile.name"
              [class]="errors?.externalUsers ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.externalUsers ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-multi-select>
            @if (errors?.externalUsers) {
              <p class="p-error">
                {{ errors.externalUsers | join }}
              </p>
            }
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [users]="recipientUsers"
              [(selectedUsers)]="data.recipientUsers"
              [isError]="$any(errors?.recipientUsers)"
              [customRequest]="true"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
            @if (errors?.recipientUsers) {
              <p class="p-error">
                {{ errors.recipientUsers | join }}
              </p>
            }
          </div>
        </div>
      </p-card>
    }

    @if (data.type === MailingTypeEnum.DEBTORS_FROM_FILE) {
      <p-card
        header="Участники рассылки"
        styleClass="mt-3">
        @if (errors?.fileDebtorTargets) {
          <div>
            <small class="p-error">
              {{ $any(errors.fileDebtorTargets) | joinWithChild }}
            </small>
          </div>
        }

        @if (!data.fileDebtorTargets?.length) {
          <p class="text-xl font-bold">
            Список участников пустой
          </p>
        }

        @if (data.fileDebtorTargets?.length) {
          <crm-table
            name="newsletter.form.contacts"
            [columns]="columns"
            [values]="data.fileDebtorTargets"
            [scrollable]="true"
            scrollHeight="300px"
            styleClass="p-datatable-sm">
            <ng-template
              #rowTemplate
              let-target="item">
              @if (toItemContactFromFile(target); as target) {
                <tr>
                  <td [ngStyle]="{ 'min-width.px': 140 }">
                    {{ target?.name }}
                  </td>
                  <td [ngStyle]="{ 'min-width.px': 140 }">
                    <div>
                      @if (data.channel === MailingChannelEnum.EMAIL) {
                        @if (target?.email) {
                          <div>
                            <a href="mailto:{{ target?.email }}">{{ target?.email }}</a>
                          </div>
                        } @else {
                          <p class="text-gray-400">Нет email</p>
                        }
                      }
                      @if (data.channel === MailingChannelEnum.SMS) {
                        @if (target.phone) {
                          <div>
                            <a href="tel:{{ target?.phone }}">{{ target?.phone | phone }}</a>
                          </div>
                        } @else {
                          <p class="text-gray-400">Нет телефона</p>
                        }
                      }
                    </div>
                  </td>
                  <td [ngStyle]="{ 'min-width.px': 100, 'max-width.px': 100 }">
                    {{ target.amount | number: '.0-0' }}
                  </td>
                  <td [ngStyle]="{ 'max-width.px': 35, 'min-width.px': 35 }">
                    <i
                      class="pi pi-times cursor-pointer hover:text-red-300 text-red-500"
                      style="font-size: 1.5rem"
                      (click)="deleteContragentFromFile(target)"></i>
                  </td>
                </tr>
              }
            </ng-template>
          </crm-table>
        }
      </p-card>
    }

    @if (canDelete) {
      <crm-newsletter-template-history-widget
        [newsletterTemplateId]="data['id']"
        class="block mt-3"></crm-newsletter-template-history-widget>
    }
  </div>
</div>

@if (canWrite) {
  <div class="grid mt-3">
    <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
      <div>
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success mr-2"
          (onClick)="onSave(data)"></crm-button>
        @if (!isModal) {
          <crm-go-back-button
            [route]="route"></crm-go-back-button>
        }
      </div>
      @if (canDelete) {
        <crm-button
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="delete.emit(data)"></crm-button>
      }
    </div>
  </div>
}

<ng-template
  #reusableTemplate
  let-data="data">
  @if (toData(data); as data) {
    <div class="formgrid grid">
      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label class="font-medium required-field">Кол-во месяцев для отбора</label>
          <p-inputNumber
            [(ngModel)]="data.attachmentLastMonthsCount"
            class="w-full {{ errors?.attachmentLastMonthsCount ? 'ng-invalid ng-dirty' : '' }}"
            styleClass="w-full {{ errors?.attachmentLastMonthsCount ? 'ng-invalid ng-dirty' : '' }}"
            [min]="0"></p-inputNumber>
          @if (errors?.attachmentLastMonthsCount) {
            <small class="p-error">
              {{ errors.attachmentLastMonthsCount | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Бюджетная статья</label>
          <crm-direction-multi-select
            [directions]="directions"
            [(selectedDirections)]="data.billingDirections"
            [styleClass]="errors?.billingDirections ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.billingDirections ? 'ng-invalid ng-dirty' : ''"
            placeholder=""
            appendTo="body"></crm-direction-multi-select>
          @if (errors?.billingDirections) {
            <small class="p-error">
              {{ errors?.billingDirections | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Статус</label>
          <crm-multi-select
            [options]="billingPaymentStatuses"
            [(selectedItems)]="data.billingPaymentStatuses"
            class="w-full {{ errors?.billingPaymentStatuses ? 'ng-invalid ng-dirty' : '' }}"
            optionValue="name"
            [styleClass]="errors?.billingPaymentStatuses ? 'ng-invalid ng-dirty' : ''"
            [showHeader]="false"
            display="comma"
            appendTo="body">
            <ng-template
              #selectedItemsTemplate
              let-bills="items">
              @for (bill of bills; track $index; let isLast = $last) {
                {{ bill?.value | billPaymentStatusName }}{{ isLast ? '' : ', ' }}
              }
            </ng-template>
            <ng-template
              #itemTemplate
              let-bill="item">
              {{ bill.value | billPaymentStatusName }}
            </ng-template>
          </crm-multi-select>
          @if (errors?.billingPaymentStatuses) {
            <small class="p-error">
              {{ errors.billingPaymentStatuses | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DEBTORS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label
            class="font-medium"
            [class.required-field]="data.type === MailingTypeEnum.DEBTORS">
            Компания
          </label>
          <crm-company-multi-select
            [(selectedCompanies)]="data.companies"
            [class]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
            [isFloatLabel]="false"
            appendTo="body"></crm-company-multi-select>
          @if (errors?.companies) {
            <small class="p-error">
              {{ errors.companies | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DEBTORS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Контрагент</label>
          <crm-contragent-multi-select
            [(selectedEntities)]="data.contragents"
            [isError]="$any(errors?.contragents)"
            appendTo="body"></crm-contragent-multi-select>
          @if (errors?.contragents) {
            <small class="p-error">
              {{ errors.contragents | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Состояние</label>
          <crm-multi-select
            [options]="attachmentStatuses"
            [(selectedItems)]="data.attachmentStatuses"
            optionValue="name"
            display="comma"
            [styleClass]="errors?.attachmentStatuses ? 'ng-invalid ng-dirty' : ''"
            class="w-full {{ errors?.attachmentStatuses ? 'ng-invalid ng-dirty' : '' }}"
            [showHeader]="false"
            appendTo="body">
            <ng-template
              #selectedItemsTemplate
              let-statuses="items">
              @for (status of statuses; track $index; let isLast = $last) {
                {{ status?.value | mailingAttachmentStatusName }}{{ isLast ? '' : ', ' }}
              }
            </ng-template>
            <ng-template
              #itemTemplate
              let-status="item">
              {{ status.value | mailingAttachmentStatusName }}
            </ng-template>
          </crm-multi-select>
          @if (errors?.attachmentStatuses) {
            <small class="p-error">
              {{ errors.attachmentStatuses | join }}
            </small>
          }
        </div>
      }
    </div>
  }
</ng-template>
